import { object, string } from 'yup';

export const newWarehouseCategoryValidationSchema = object().shape({
    name: string()
        .min(2, ('Too Short!'))
        .max(50, 'Too Long!')
        .required('Required'),
});